import { render, staticRenderFns } from "./Incorporated.vue?vue&type=template&id=59497606&scoped=true"
import script from "./Incorporated.vue?vue&type=script&lang=js"
export * from "./Incorporated.vue?vue&type=script&lang=js"
import style0 from "./Incorporated.vue?vue&type=style&index=0&id=59497606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59497606",
  null
  
)

export default component.exports